export enum InvoiceType {
    REGULAR = 'REGULAR',
    CORRECTION = 'CORRECTION',
    REFUND = 'REFUND',
}
